<div class="container">
  <mat-card class="example-card">
    <mat-card-header>
      <div
        mat-card-avatar
        class="example-header-image"
      ></div>
      <mat-card-title>{{success ? titleSuccess : titleFail}}</mat-card-title>
      <mat-card-subtitle>{{success ? subTitleSuccess : subTitleFail}}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <span [innerHtml]="description">
      </span>
    </mat-card-content>
    <img
      *ngIf="success"
      mat-card-image
      [src]="imagePath"
      alt="Photo of licensing"
    >
  </mat-card>
</div>
